import Raven from 'raven-js';
import * as angular from 'angular'
import APP_VERSION from './appVersion'

let activeSentry = "true"

let dsn = activeSentry == "true" ? "https://25a9527816234f048b578e9429f74b5a@sentry.io/1198219" : null

let environment = "PRODUCTION_CAMPONES"

Raven.config(dsn,{
    environment: environment,
    release: APP_VERSION
}).addPlugin(require('raven-js/plugins/angular'), angular).install();
